import React from 'react'

export default function Security() {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="18.462" height="20" viewBox="0 0 18.462 20">
  <path id="Security" d="M13.231,3a43.267,43.267,0,0,0-7.879.864l0,0A1.67,1.67,0,0,0,4,5.5v5c0,8.665,8.41,12.287,8.41,12.287a1.681,1.681,0,0,0,1.639,0h0s8.41-3.622,8.41-12.287v-5a1.67,1.67,0,0,0-1.352-1.636A43.268,43.268,0,0,0,13.231,3Zm0,5.833a2.492,2.492,0,0,1,.839,4.847v2.653a.839.839,0,0,1-1.678,0V13.68a2.492,2.492,0,0,1,.839-4.847Z" transform="translate(-4 -3)" fill="#fff"/>
</svg>

  )
}